import { http } from './http';
import { file } from './file';
import { tool } from './tool';
import { asset } from './asset';

export const $http = http;
export const $file = file;
export const $tool = tool;
export const $asset = asset;
